import styled from "styled-components";

export const FormInputBox = styled.div`
  gap: 26px;
  flex: 1;
  width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;

  & + div {
    margin-top: 18px;
  }
`;

export const FormInputTitle = styled.h4`
  width: 100%;
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  justify-content: space-between;

  span {
    color: ${(props) => props.theme.colors.black50};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;

export const FormInputContent = styled.div`
  gap: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
